// libs
import React from 'react';

// components
import SizeGuide from 'shared/layouts/SizeGuide';
import { OverlaySheetContext, SHEET_TRANSITION } from 'shared/components/OverlaySheet';

// styles
import { OverlaySheet, Container } from './styles';

function SizeGuideBottomSheet({ onClose }: { onClose: () => void }) {
  return (
    <OverlaySheet
      onHide={onClose}
      transitionFrom={SHEET_TRANSITION.RIGHT}
      navKey="sizeguide"
      disableNav
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <Container>
            <SizeGuide onClose={doHide} />
          </Container>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheet>
  );
}

export default SizeGuideBottomSheet;
